import React, { useEffect, useState } from "react";
import {
  ProjectsHeroImg,
  ProjectsHeroProps,
} from "../../../interfaces/projects";
import { scrollToDiv, transformCloudinaryImg } from "../../../services/utils";
import Carousel from "../Carousel";
import Icon from "../Icon";
import "./hero.scss";

const ProhectsHero: React.FC<ProjectsHeroProps> = ({ imgs }) => {
  const [projectImgs, setProjectImgs] = useState<any>([]);

  useEffect(() => {
    if (typeof window !== `undefined`) {
      const { clientWidth } = document.documentElement;

      setProjectImgs(
        imgs.map(({ img, label }: ProjectsHeroImg) => ({
          img: transformCloudinaryImg(
            img,
            clientWidth <= 768
              ? "c_fill,f_auto,h_800,q_60,w_500"
              : "c_scale,f_auto,q_60,w_1920"
          ),
          label,
        }))
      );
    }
  }, []);
  return (
    <section className="projects-hero">
      <Carousel
        autoPlay={true}
        renderDots={() => <span />}
        renderArrowRight={({ handleNext }) => (
          <div className="arrow-control arrow-right" onClick={handleNext}>
            <Icon name="chevron-right" color="#fff" />
          </div>
        )}
        renderArrowLeft={({ handlePrev }) => (
          <div className="arrow-control arrow-left" onClick={handlePrev}>
            <Icon name="chevron-left" color="#fff" />
          </div>
        )}
        interval={4000}
        loop={true}
      >
        {projectImgs.map((item: ProjectsHeroImg, i: number) => (
          <div key={i} className="carousel-item">
            <img src={item?.img} className="object-cover" loading="lazy" />
            <div className="overlay">
              <div
                className="label montserrat-medium text-center"
                dangerouslySetInnerHTML={{
                  __html: item?.label,
                }}
              />
            </div>
          </div>
        ))}
      </Carousel>
      <div className="bottom-content">
        <div
          className="arrow bounce"
          onClick={() => scrollToDiv("brouchure", 1000, 60)}
        >
          <Icon name="arrow-down" color="#fff" />
        </div>
      </div>
    </section>
  );
};

export default ProhectsHero;
